if (!customElements.get("grid-video-slider")){
  class GridVideoSlider extends HTMLElement {
    constructor() {
      super();
      this.videoPosters = this.querySelectorAll('.video-section__poster');
      this.allVideos = this.querySelectorAll('.video-section__media');
      this.pauseIcons = this.querySelectorAll('.deferred-media__pause-button');
      this.boundLoadContent = this.loadContent.bind(this);
      this.boundToggleVideo = this.toggleVideo.bind(this);
      this.initialize();
    }
  
    initialize() {
      this.isMobileView = window.innerWidth < 750;
      this.videoPosters.forEach(poster => {
        poster.addEventListener("click", this.boundLoadContent);
      });
      this.allVideos.forEach(video => {
        video.addEventListener("click", this.boundToggleVideo);
      });
    }
    stopAllMedia(excludeVideo = null){
      this.allVideos.forEach(video => {
        const videosectionMedia = video || video?.closest(".video-section__media");
        const videoElement = videosectionMedia?.querySelector("video");

        if (excludeVideo && videoElement === excludeVideo) return;

        if (videosectionMedia?.getAttribute("loaded") || (videoElement?.tagName === 'VIDEO' && !videoElement.paused)) {
          const pauseIcon = videosectionMedia?.querySelector(".deferred-media__pause-button");
          pauseIcon?.classList.remove('hidden');
          videoElement?.pause();
        }
      });
   }
  
    toggleVideo(event) {

      if (!event || event?.target.tagName.toLowerCase() !== 'video') return;

      const videoElement = event.target;
      const VideoMedia = videoElement.closest(".video-section__media");
      const pauseIcon = VideoMedia.querySelector(".deferred-media__pause-button");

      this.stopAllMedia(videoElement);

      if (videoElement.paused) {
        videoElement.play().catch(err => console.error("[VideoSlider] Error playing video on toggle:", err));
        pauseIcon.classList.add('hidden');
      } else {
        videoElement.pause();
        pauseIcon.classList.remove('hidden');
      }
  }

  
    loadContent(event, focus = true, videoElement = null) {
      try {
        if (typeof window.pauseAllMedia === "function") {
          this.stopAllMedia();
        }
        const target = event?.target || videoElement;
        const container = target?.closest(".video-section__media") || videoElement;
  
        if (!container || container.getAttribute("loaded")) return;
  
        const template = container.querySelector("template");
        if (!template) throw new Error("Template not found inside video container.");
  
        const content = template.content.firstElementChild.cloneNode(true);
        container.setAttribute("loaded", "true");
        const deferredMedia = container.appendChild(content);
  
        if (deferredMedia?.play) {
          deferredMedia.play().catch(err => console.error("[VideoSlider] Error playing deferred video:", err));
        }
      } catch (error) {
        console.error("[VideoSlider] loadContent error:", error);
      }
    }
  
    disconnectedCallback() {
      this.videoPosters.forEach(poster => {
        poster.removeEventListener("click", this.boundLoadContent);
      });
  
      this.allVideos.forEach(video => {
        video.removeEventListener("click", this.boundToggleVideo);
      });
    }
  }
  
  customElements.define("grid-video-slider", GridVideoSlider);
}